import { AppText } from "@toothfairy/shared-ui";
import React from "react";
import { View } from "react-native";
import { useTranslation } from "react-i18next";

const UserMessageItem = ({ message, currentTheme }) => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "flex-start",
        paddingVertical: 4,
        paddingHorizontal: 8,
        marginLeft: 32, // Indent to align with step content
        marginBottom: 2,
      }}
    >
      {/* User indicator */}
      <View
        style={{
          width: 16,
          height: 16,
          borderRadius: 8,
          backgroundColor: currentTheme?.theme?.primary,
          justifyContent: "center",
          alignItems: "center",
          marginRight: 6,
        }}
      >
        <AppText
          style={{
            fontSize: 8,
            color: "#FFFFFF",
            fontWeight: "bold",
          }}
          preventTranslation
        >
          {message.userName?.charAt(0)?.toUpperCase() || "U"}
        </AppText>
      </View>

      {/* Message content */}
      <View
        style={{
          flex: 1,
          backgroundColor: currentTheme?.theme?.softBackgroundColor,
          borderRadius: 6,
          padding: 8,
          borderLeftWidth: 2,
          borderLeftColor: currentTheme?.theme?.primary,
        }}
      >
        <AppText
          fontWeight="500"
          style={{
            fontSize: currentTheme?.theme?.extra_small_font_size,
            color: currentTheme?.theme?.primary,
            marginBottom: 2,
          }}
        >
          {message.userName || t("planner.steps.you", { defaultValue: "You" })}
        </AppText>

        <AppText
          numberOfLines={2}
          style={{
            fontSize: currentTheme?.theme?.extra_small_font_size,
            color: currentTheme?.theme?.font_color,
          }}
          preventTranslation
        >
          {message.text}
        </AppText>
      </View>
    </View>
  );
};

export default UserMessageItem;
